import SpriteSymbol from "../../../../../../../../../root/.zend/plugin/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../root/.zend/plugin/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SystemTencentOS",
  "use": "SystemTencentOS-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"SystemTencentOS\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.9752 3.6001H5.17519L2.02519 20.4001H18.8252L21.9752 3.6001ZM9.34238 17.7751L10.7205 10.4251H7.80019L6.75019 8.5876H11.065L11.5572 5.9626L17.5127 10.4251H13.083L12.0986 15.6751H15.4127L17.2502 17.7751H9.34238Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol